export default __webpack_public_path__ + "static/media/pin.dcfc16bc.svg";